import { render, staticRenderFns } from "./tableView.vue?vue&type=template&id=50e856b2&scoped=true"
import script from "./tableView.vue?vue&type=script&lang=js"
export * from "./tableView.vue?vue&type=script&lang=js"
import style0 from "./tableView.vue?vue&type=style&index=0&id=50e856b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e856b2",
  null
  
)

export default component.exports